import { Card, CardContent, Stack, Typography } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { PageHeader } from '@/components/PageHeader';

/**
 * Placeholder is used by every page during Tour 1 so the routing tree
 * compiles. Tour 2+ replaces these with real pages — naming convention
 * is `pages/<role>/<feature>Page.tsx`.
 */
export function Placeholder({
  title,
  description,
  tour,
}: {
  title: string;
  description?: string;
  tour: 2 | 3 | 4 | 5 | 6;
}) {
  return (
    <>
      <PageHeader title={title} subtitle={description} />
      <Card>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <ConstructionIcon color="action" />
            <Stack>
              <Typography variant="subtitle1" fontWeight={600}>
                Coming in tour {tour}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                The route is wired and the data layer (services + serializers)
                is ready. The UI for this page lands in tour {tour}.
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
